import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'u2000-separator',
    templateUrl: './U2000_separator.component.html',
    styleUrls: ['./U2000_separator.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class U2000_SeparatorComponent {
    @Input() label: string;
    @Input() backgroundColor: string;

    constructor() {}
}
